const DEFAULT_DELIVERY_ZIP = 'na';
const DEFAULT_BD_WHS = 'na';
const DEFAULT_STORE_LOCATION = { storeLocation: { city: 'na' } };

interface CookieData {
    invCheckPostalCode?: string;
    STORELOCATION?: { storeLocation?: { city?: string } };
    WC_BD_ZIP?: string;
    WC_BD_WHS?: string;
}

export const getLocalWarehouseFromCookies = (
    cookies: CookieData,
    { isBD }: { isBD?: boolean } = {},
) => {
    const {
        invCheckPostalCode: BCdeliveryZip = DEFAULT_DELIVERY_ZIP,
        STORELOCATION: BCstoreLocation = DEFAULT_STORE_LOCATION,
        WC_BD_ZIP: BDDeliveryZip = DEFAULT_DELIVERY_ZIP,
        WC_BD_WHS: BDStoreLocation = DEFAULT_BD_WHS,
    } = cookies;

    let deliveryZip = BCdeliveryZip;
    let localWH = BCstoreLocation?.storeLocation?.city;

    if (isBD) {
        deliveryZip = BDDeliveryZip;
        localWH = BDStoreLocation
            ? `${BDStoreLocation}`.split('|')?.[0]
            : DEFAULT_BD_WHS;
    }

    return { deliveryZip, localWH };
};
